/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Schedule from './schedule';
import ScheduleDetail from './schedule-detail';
import ScheduleUpdate from './schedule-update';
import ScheduleDeleteDialog from './schedule-delete-dialog';

const ScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Schedule />} />
    <Route path="new" element={<ScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<ScheduleDetail />} />
      <Route path="edit" element={<ScheduleUpdate />} />
      <Route path="delete" element={<ScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ScheduleRoutes;
